import React from "react";
import Footer from "./Footer";
import { Link, NavLink } from "react-router-dom";

function About() {
  return (
    <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-16 static">
    <div className="hidden sm:mb-8 sm:flex sm:justify-center">
      <div className="relative rounded-full px-3 py-1 text-sm/6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
        The fastest and easiest way to create a fancy game name.{' '}
        <Link to="/Creation" className="font-semibold text-indigo-600"><span aria-hidden="true" className="absolute inset-0" />
        Read Tutorial <span aria-hidden="true">&rarr;</span></Link>
      </div>
    </div>
    <div className="text-center">
      <h1 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white">
        Keep up with the latest name trends.
      </h1>
      <p className="mt-8 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">
      Use the names in games such as Counter-Strike 2, Fortnite, Valorant, ROBLOX, League of Legends and Dota 2, and more.
      </p>
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <Link to="/Create" className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Get started</Link>
        <Link to="/Creation" className="text-sm/6 font-semibold text-gray-900">
          Learn more <span aria-hidden="true">→</span>
        </Link>
      </div>
    </div>
  </div>
  );
}

export default About;